"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.excludedClothSlugs = void 0;
exports.getRefashionSlugForRepairBonusItem = getRefashionSlugForRepairBonusItem;
exports.getRepairBonusAmount = getRepairBonusAmount;
exports.getRepairBonusAmountForCloth = getRepairBonusAmountForCloth;
exports.repairBonusDiscount = void 0;
var _pricings = _interopRequireWildcard(require("../pricings/v9/pricings"));
var _pricings2 = _interopRequireWildcard(require("../pricings/v12/pricings"));
var _pricings3 = _interopRequireWildcard(require("../pricings/v13/pricings"));
var _orderPriceUtils = require("./orderPriceUtils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var discountsSettings = {
  HOLE: {
    label: 'trou/accroc/déchirure',
    value: 7,
    refashionSlug: 'TROU_ACCROC_DECHIRURE'
  },
  LINING_SIMPLE: {
    label: 'doublure - simple',
    value: 10,
    refashionSlug: 'DOUBLURE_SIMPLE'
  },
  LINING_COMPLEX: {
    label: 'doublure - complexe',
    value: 25,
    refashionSlug: 'DOUBLURE_COMPLEXE'
  },
  ZIP_SMALL: {
    label: 'zip - petit',
    value: 8,
    refashionSlug: 'FERMETURE_ECLAIR_PETITE'
  },
  ZIP_BIG: {
    label: 'zip - grand',
    value: 15,
    refashionSlug: 'FERMETURE_ECLAIR_LONGUE'
  },
  UNTIED_UNLINED: {
    label: 'couture défaite - non doublé',
    value: 6,
    refashionSlug: 'COUTURE_DEFAITE_NON_DOUBLE'
  },
  UNTIED_LINED: {
    label: 'couture défaite - non doublé',
    value: 8,
    refashionSlug: 'COUTURE_DEFAITE_DOUBLE'
  },
  SHOE_OVERSHOE: {
    label: 'patin',
    value: 8,
    refashionSlug: 'PATIN'
  },
  SHOE_CAP: {
    label: 'bonbout (embout de talon)',
    value: 7,
    refashionSlug: 'BONBOUT'
  },
  SHOE_SEWING: {
    label: 'couture / collage',
    value: 8,
    refashionSlug: 'COUTURE_COLLAGE'
  },
  SHOE_OVERSHOE_AND_SEWING: {
    label: 'patin + couture',
    value: 16,
    refashionSlug: ['PATIN', 'COUTURE_COLLAGE']
  },
  SHOE_RESOLE_RUBBER: {
    label: 'ressemelage gomme',
    value: 18,
    refashionSlug: 'RESSEMELAGE_GOMME'
  },
  SHOE_RESOLE_LEATHER: {
    label: 'ressemelage cuir',
    value: 25,
    refashionSlug: 'RESSEMELAGE_CUIR'
  },
  SHOE_ZIP_SMALL: {
    label: 'zip - <20 cm',
    value: 10,
    refashionSlug: 'FERMETURE_ECLAIR_INF_20_CM'
  },
  SHOE_ZIP_BIG: {
    label: 'zip - >20 cm',
    value: 14,
    refashionSlug: 'FERMETURE_ECLAIR_SUP_20_CM'
  }
};
var excludedClothSlugs = exports.excludedClothSlugs = ['ride', 'acce', 'little_acce', 'bag', 'wallet', 'belt', 'autr'];
function buildRepairBonusDiscount() {
  var repairBonusDiscount = {
    name: 'Bonus Réparation',
    type: 'COMMISSION',
    value: 0,
    unit: 'EUROS',
    discountOnItems: [],
    reason: 'REPAIR_BONUS',
    excludedFabrics: ['leather']
  };
  var itemIdsByDiscountType = {
    HOLE: [],
    LINING_SIMPLE: [],
    LINING_COMPLEX: [],
    ZIP_SMALL: [],
    ZIP_BIG: [],
    UNTIED_UNLINED: [],
    UNTIED_LINED: [],
    SHOE_OVERSHOE: [],
    SHOE_CAP: [],
    SHOE_SEWING: [],
    SHOE_OVERSHOE_AND_SEWING: [],
    SHOE_RESOLE_RUBBER: [],
    SHOE_RESOLE_LEATHER: [],
    SHOE_ZIP_SMALL: [],
    SHOE_ZIP_BIG: []
  };
  var allPricing = [].concat(_toConsumableArray(_pricings3["default"]), _toConsumableArray(_pricings3.leatherGoodsPricing), _toConsumableArray(_pricings2["default"]), _toConsumableArray(_pricings2.leatherGoodsPricing), _toConsumableArray(_pricings["default"]), _toConsumableArray(_pricings.leatherGoodsPricing));
  allPricing.forEach(function (cloth) {
    if (excludedClothSlugs.includes(cloth.slug)) return;
    var processItems = function processItems(items) {
      items.forEach(function (item) {
        if (item.repairBonus) {
          var key = _typeof(item.repairBonus) === 'object' ? item.repairBonus[cloth.slug === 'mari' ? 'mari' : 'SIMPLE'] : item.repairBonus;
          if (!itemIdsByDiscountType[key]) itemIdsByDiscountType[key] = [];
          itemIdsByDiscountType[key].push(item.id);
        }
      });
    };
    cloth.categories.forEach(function (category) {
      if (category.subCategories && category.subCategories.length) {
        category.subCategories.forEach(function (subCategory) {
          return processItems(subCategory.items);
        });
      } else {
        processItems(category.items);
      }
    });
  });

  // remove doubles
  Object.entries(itemIdsByDiscountType).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      itemIds = _ref2[1];
    itemIdsByDiscountType[key] = _toConsumableArray(new Set(itemIds));
  });
  Object.entries(itemIdsByDiscountType).forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
      key = _ref4[0],
      itemIds = _ref4[1];
    var value = discountsSettings[key].value;
    repairBonusDiscount.discountOnItems.push({
      itemIds: itemIds,
      value: value
    });
  });
  return repairBonusDiscount;
}
var repairBonusDiscount = exports.repairBonusDiscount = buildRepairBonusDiscount();

/**
 * @param { import("../entities/types").Order } order
 * @returns { number }
 */
function getRepairBonusAmount(order) {
  var repairBonusDiscountInOrder = order.discounts.find(function (discount) {
    return discount.reason === 'REPAIR_BONUS';
  });
  if (!repairBonusDiscountInOrder) return 0;
  return (0, _orderPriceUtils.getAmountForDiscountOnItem)(order, repairBonusDiscountInOrder, false);
}

/**
 * @param { string } itemId
 * @param { Record<string, { repairBonus?: string | Record<string, string> }> } pricingInverse
 * @param { string } clothType
 * @returns { string | null }
 */
function getRefashionSlugForRepairBonusItem(itemId, pricingInverse, clothType) {
  if (!pricingInverse) throw new Error('[getRefashionSlugForRepairBonusItem] Missing pricingInverse');
  if (!pricingInverse[itemId]) throw new Error("[getRefashionSlugForRepairBonusItem] pricingInverse[itemId] not found, itemId: ".concat(itemId));
  var key = pricingInverse[itemId].repairBonus;
  if (!key) return null;
  if (_typeof(key) === 'object') {
    if (!clothType) throw new Error("[getRefashionSlugForRepairBonusItem] Missing clothType for repairBonus object, itemId: ".concat(itemId, ", key: ").concat(key));
    if (clothType === 'DEFAULT') return discountsSettings[key.mari].refashionSlug;
    if (!key[clothType]) throw new Error("[getRefashionSlugForRepairBonusItem] key[".concat(clothType, "] not found, itemId: ").concat(itemId, ", key: ").concat(key));
    return discountsSettings[key[clothType]].refashionSlug;
  }
  if (!discountsSettings[key]) throw new Error("[getRefashionSlugForRepairBonusItem] discountsSettings[".concat(key, "] not found, itemId: ").concat(itemId));
  return discountsSettings[key].refashionSlug;
}
function getRepairBonusAmountForCloth(cloth, discount) {
  var _discount$excludedFab;
  if ((_discount$excludedFab = discount.excludedFabrics) !== null && _discount$excludedFab !== void 0 && _discount$excludedFab.includes(cloth.fabric)) return 0;
  return cloth.items.reduce(function (acc, item) {
    var _discount$discountOnI;
    var itemDiscount = (_discount$discountOnI = discount.discountOnItems) === null || _discount$discountOnI === void 0 ? void 0 : _discount$discountOnI.find(function (discountOnItems) {
      return discountOnItems.itemIds.includes(item.id);
    });
    if (!itemDiscount) return acc;
    return acc + itemDiscount.value * item.quantity;
  }, 0);
}